module.exports = __webpack_public_path__ + "static/media/novedades.85a5b355.svg";